<template>
  <div>
    <div class="py-1 d-flex">
      <b-select
        v-model="role_id"
        :options=" optionsAllRole"
        placeholder="Role"
      />
      <b-btn
        v-if="!addRoleLoad"
        :disabled="!role_id"
        variant="primary"
        class="ml-1"
        @click="addRole"
      >
        Add
      </b-btn>
      <b-button
        v-if="addRoleLoad"
        variant="primary"
        disabled
        class="mr-1 d-flex align-items-center"
      >
        <b-spinner
          v-for="item in 3"
          :key="item"
          small
          type="grow"
        />
      </b-button>
    </div>
    <b-table
      small
      :fields="fields"
      :items="dataTable"
      responsive="sm"
      :busy="dataLoad"
    >
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle" />
          <strong>Loading...</strong>
        </div>
      </template>
      <template #cell(remove)="data">
        <feather-icon
          v-if="removeRoleLoad !== data.item.name"
          icon="TrashIcon"
          size="18"
          class="text-danger cursor-pointer"
          @click="removeRole(data.item.name)"
        />
        <b-spinner
          v-else
          small
          label="Spinning"
          class="text-danger"
        />
      </template>
    </b-table>
  </div>
</template>

<script>
// import VSelect from 'vue-select'
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import decryptData from '@/store/auth/decryptData'

export default {
//   components: {
//     'v-select': VSelect,
//   },
  props: {
    sourceData: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      fields: [
        { key: 'name', label: 'Roles' },
        { key: 'remove', label: 'Delete' },
      ],
      dataLoad: false,
      addRoleLoad: false,
      removeRoleLoad: null,
      dataTable: [],
      role_id: '',
    }
  },
  computed: {
    optionsAllRole() {
      return this.$store.getters['generalData/roles/roles'].filter(item => item.value !== null)
    },
  },
  watch: {
    sourceData: {
      immediate: true, // run on component mount
      handler(newVal) {
        if (newVal) {
          this.getRoleByName()
        }
      },
    },
  },
  async mounted() {
    if (!this.$store.getters['generalData/roles/roleLoaded']) {
      await this.$store.dispatch('generalData/roles/fetchRoles')
    }
  },

  methods: {
    async getRoleByName() {
      try {
        this.dataLoad = true

        const response = await axios.get(`/permissions/${this.sourceData}`)
        const data = decryptData(response.data.payload)?.data?.permission?.roles
        this.dataTable = data
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            icon: 'BellIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.dataLoad = false
      }
    },
    addRole() {
      this.addRoleLoad = true
      axios
        .post(`/permissions/role/${this.role_id}/assign`,
          { permission: this.sourceData })
        .then(() => {
          this.getRoleByName()
          this.role_id = ''
        })
        .finally(() => {
          this.addRoleLoad = false
        })
    },
    removeRole(id) {
      this.removeRoleLoad = id
      axios.delete(`/permissions/role/${id}/revoke`, {
        data: {
          permission: this.sourceData,
        },
      })
        .then(() => {
          this.getRoleByName()
        })
        .finally(() => {
          this.removeRoleLoad = null
        })
    },
  },
}
</script>
